import { API } from '@/shared/api/modules';
import type { GetAlertsTopCategoriesRequestDto } from '@/shared/api/modules/market-intel';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export const getAlertTopCategoriesQueryOptions = (
  params: GetAlertsTopCategoriesRequestDto
) =>
  queryOptions({
    queryKey: ['get-alert-top-categories', params],
    queryFn: async ({ signal }) =>
      await API.marketIntel.getAlertTopCategories(params, { signal }),
    enabled: !!params.facilityId && !!params.from && !!params.to,
    placeholderData: keepPreviousData,
  });
